var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.styling),attrs:{"id":"painted-area"}})
}
var staticRenderFns = []

export { render, staticRenderFns }